import "./about_you_section.scss";
import { useEffect, useRef, useState } from "react";
import { TextInput } from "@sprout/text_input.tsx";
import useTranslation from "@hooks/use_translation.ts";
import ModalFooter from "./modal_footer.tsx";
import useSectionSave from "./use_section_save.ts";
import type { SectionProps } from "./types.ts";

const BIO_MAX_LENGTH = 500;

const AboutYouSection = ({ data, onClose, source }: SectionProps) => {
  const { t } = useTranslation("user", { keyPrefix: "profile_checklist.modals.about_you" });
  const { save, saving, errors } = useSectionSave();

  const [bio, setBio] = useState(data.bio || "");
  const bioRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const textarea = bioRef.current;
    if (!textarea) return;

    const frame = requestAnimationFrame(() => {
      textarea.focus();
      textarea.setSelectionRange(textarea.value.length, textarea.value.length);
    });
    return () => cancelAnimationFrame(frame);
  }, []);

  const handleSave = async () => {
    const formData = new FormData();
    formData.append("personal_info[bio]", bio);

    const success = await save(formData);
    if (success) onClose();
    return success;
  };

  return (
    <>
      <TextInput
        id="about-you-bio"
        ref={bioRef}
        className="about_you_bio"
        label={null}
        placeholder={t("placeholder")}
        value={bio}
        onChange={(e) => setBio(e.currentTarget.value)}
        multiline
        rows={5}
        maxLength={BIO_MAX_LENGTH}
        help={t("character_count", { used: bio.length, max: BIO_MAX_LENGTH })}
        error={errors.bio?.[0]}
      />
      <ModalFooter
        section="about_you"
        onSave={handleSave}
        onCancel={onClose}
        saving={saving}
        source={source}
      />
    </>
  );
};

export default AboutYouSection;
